import Plyr from 'plyr'
import processStream from './stream-channel'

class Video {
	constructor() {
		this.stream()
	}

	stream() {
		try {
			if (document.querySelector('#player-element')) {
				processStream('player-element', false, false, true)
			}
		} catch (error) {
			console.log('Video.stream', { message: error.message })
		}
	}

}

export default window.addEventListener('DOMContentLoaded', function (evt) {
	new Video()
})
